export default "__VITE_ASSET__QIswwUJN__"